import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import _ from 'lodash';
import React, {
  useCallback,
  useEffect,
  useState,
  useMemo,
} from 'react';
import { getOptionByValueInList } from '../../utils/general/general-utils';
import QCXAutocompleteSelect from '../autocomplete-select/QCXAutocompleteSelect';
import i18n from '../../i18n';

const list = [
  {
    label: i18n.t('com.muralis.qcx.produtorAgropecuario').toUpperCase(),
    value: 'PRODUTOR_AGROPECUARIO',
  },
  {
    label: i18n.t('com.muralis.qcx.orgaoFomentoDesenvolvimentoAgropecuario').toUpperCase(),
    value: 'ORGAO_DE_FOMENTO_E_DESENVOLVIMENTO_AGROPECUARIO',
  },
  {
    label: i18n.t('com.muralis.qcx.outros').toUpperCase(),
    value: 'OUTROS',
  },
];

export default function QCXSelectMotivoDesoneracaoICMSAutocomplete({
  label,
  name,
  initialValues,
  ...restProps
}) {
  const [defaultValue, setDefaultValue] = useState('');

  useEffect(() => {
    const value = list.find((item) => item?.value === _.get(initialValues, name));
    if (value) {
      setDefaultValue(value);
    } else {
      setDefaultValue('');
    }
  }, [list, initialValues]);

  const filterOptions = useMemo(() => (
    createFilterOptions({
      stringify: (option) => (
        option.label + option.value
      ),
    })
  ), []);

  const getOptionLabel = useCallback((item) => (
    item?.label || ''
  ), []);

  const getOptionValue = useCallback((item) => (
    item?.value || ''
  ), []);

  return (
    <QCXAutocompleteSelect
      label={label}
      id={name}
      name={name}
      options={list}
      filterOptions={filterOptions}
      defaultValue={defaultValue}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      {...restProps}
    />
  );
}

function getMotivoDesoneracaoICMSLabelByValue(value) {
  const foundOption = getOptionByValueInList(list, value);
  return foundOption && foundOption?.label;
}

export {
  getMotivoDesoneracaoICMSLabelByValue,
};
